export default __webpack_public_path__ + "static/home-banner1-mobile-7b1b2efdcb9c8f1a850f9002d69a2572.jpg";